import ReduxThunk from 'redux-thunk';
import {createStore, applyMiddleware} from 'redux';
import {composeWithDevTools} from 'redux-devtools-extension';

// import reducers from '@dmtla/cnplus-app-data/reducers';
import reducers from './reducers';

export const appVersion = 2;

const initialState = () => {
    let state = {};

    if (
        localStorage.getItem('version')
            ? parseFloat(localStorage.getItem('version')) < appVersion
            : true
    ) {
        localStorage.clear();
        localStorage.setItem('version', appVersion.toString());
    }

    if (localStorage.getItem('persistedState'))
        try {
            state = JSON.parse(localStorage.getItem('persistedState'));
        } catch (err) {}

    //remove bogus data
    delete state.home;
    delete state.show;
    delete state.episode;
    delete state.drm;
    delete state.video;
    delete state.ui;
    delete state.kidsActivities;
    delete state.comics;
    delete state.lives;
    delete state.pnp;
    delete state.movie;
    delete state.games;
    delete state.stickers;
    delete state.sponsor;

    return state;
};

const store = createStore(
    reducers,
    initialState(),
    composeWithDevTools(applyMiddleware(ReduxThunk)),
);

store.subscribe(() => {
    let state = {...store.getState()};
    delete state.home;
    delete state.show;
    delete state.episode;
    delete state.drm;
    delete state.video;
    delete state.ui;
    delete state.kidsActivities;
    delete state.comics;
    delete state.lives;
    delete state.pnp;
    delete state.movie;
    delete state.games;

    if (state.user) {
        delete state.user.storage;
        state.user.pool && delete state.user.pool.storage;
    }

    localStorage.setItem('persistedState', JSON.stringify(state));
});

export default store;
